const styles = (theme) => ({
  root: {
    '& .CardIcon': {
      color: theme.palette.custom.letters,
      backgroundColor: theme.palette.background.lighter,
      borderColor: theme.palette.border.lighter,
      borderWidth: '1px',
    },
    '& .Card': {
      borderColor: theme.palette.border.light,
      borderWidth: '1px',
    },
  },
  card: {
    paddingBottom: `8px !important`,
  },
});

export default styles;
